(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inutec-cart-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inutec-cart-help')) {
    customElements.define('inutec-cart-help', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        if (typeof this.dialog.showModal !== 'function') return;
        this.form = this.querySelector('form');
        this.strings = JSON.parse(this.querySelector('[data-cart-help-strings]').textContent);
        this.status = this.querySelector('[data-cart-help-status]');
        this.submitButton = this.querySelector('[data-cart-help-submit]');
        this.sequence = 0;
        const reveal = () => document.querySelectorAll('[data-cart-help-actions]').forEach(el => { el.hidden = false; });
        reveal();
        this.observer = new MutationObserver(reveal);
        this.observer.observe(document.body, { childList: true, subtree: true });
        document.addEventListener('click', this.onTrigger = event => {
          const trigger = event.target.closest('[data-cart-help-open]');
          if (!trigger) return;
          this.trigger = trigger;
          const drawer = trigger.closest('cart-drawer');
          this.drawer = drawer || null;
          if (drawer && typeof drawer.close === 'function') drawer.close();
          this.open(trigger.dataset.cartHelpOpen);
        });
        this.querySelectorAll('[data-cart-help-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('close', () => {
          this.sequence += 1;
          if (this.drawer && typeof this.drawer.open === 'function') this.drawer.open();
          else if (this.trigger && this.trigger.isConnected) this.trigger.focus();
        });
        this.querySelector('[data-cart-help-copy]').addEventListener('click', async () => {
          const input = this.querySelector('[data-cart-help-link]');
          const status = this.querySelector('[data-cart-help-copy-status]');
          try {
            await navigator.clipboard.writeText(input.value);
            status.textContent = this.strings.copied;
          } catch {
            input.focus();
            input.select();
            status.textContent = this.strings.copy_manual;
          }
        });
        this.form.addEventListener('submit', event => {
          if (!this.cart || !this.cart.items.length) { event.preventDefault(); return; }
          this.querySelector('[data-cart-help-body]').value = this.buildBody();
          try { sessionStorage.setItem('inutec-cart-help-pending', this.mode); } catch {}
        });
        const returning = new URLSearchParams(location.search).has('cart_help') || location.hash === '#InutecCartHelpForm';
        if (returning) {
          let mode = 'check';
          try { mode = sessionStorage.getItem('inutec-cart-help-pending') || mode; } catch {}
          const success = !this.querySelector('[data-cart-help-success]').hidden;
          const errors = !this.querySelector('[data-cart-help-server-errors]').hidden;
          if (success) {
            this.setMode(mode);
            this.querySelector('[data-cart-help-fields]').hidden = true;
            this.dialog.showModal();
            try { sessionStorage.removeItem('inutec-cart-help-pending'); } catch {}
          } else if (errors) this.open(mode, true);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onTrigger);
        if (this.observer) this.observer.disconnect();
      }

      setMode(mode) {
        this.mode = ['check', 'save', 'quote'].includes(mode) ? mode : 'check';
        const save = this.mode === 'save';
        const quote = this.mode === 'quote';
        this.querySelector('#InutecCartHelpTitle').textContent = this.strings[this.mode];
        this.querySelector('#InutecCartHelpIntro').textContent = this.strings[`${this.mode}_intro`];
        this.querySelector('[data-cart-help-purpose]').value = this.strings[this.mode];
        this.querySelector('[data-cart-help-save]').hidden = !save;
        this.querySelectorAll('[data-cart-help-advice]').forEach(row => {
          row.hidden = save;
          row.querySelectorAll('input,textarea').forEach(input => { input.disabled = save; });
        });
        this.querySelector('[data-cart-help-quote]').hidden = !quote;
        this.querySelectorAll('[data-cart-help-quote] input, [data-cart-help-quote] select').forEach(input => { input.disabled = !quote; input.required = quote; });
        this.querySelector('[data-cart-help-notes-label]').textContent = this.strings[quote ? 'quote_notes' : 'check_notes'];
        this.submitButton.textContent = this.strings[save ? 'save_send' : 'send'];
      }

      async open(mode, keepErrors = false) {
        this.setMode(mode);
        this.cart = null;
        this.link = '';
        this.submitButton.disabled = true;
        this.querySelector('[data-cart-help-fields]').hidden = false;
        this.querySelector('[data-cart-help-success]').hidden = true;
        if (!keepErrors) this.querySelector('[data-cart-help-server-errors]').hidden = true;
        this.querySelector('[data-cart-help-cart]').hidden = true;
        this.querySelector('[data-cart-help-copy-status]').textContent = '';
        this.status.textContent = this.strings.loading;
        if (!this.dialog.open) this.dialog.showModal();
        this.querySelector('#InutecCartHelpTitle').focus();
        const sequence = ++this.sequence;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const response = await fetch(`${this.dataset.cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
          if (!response.ok) throw new Error('cart');
          const cart = await response.json();
          if (sequence !== this.sequence) return;
          if (!cart.items || !cart.items.length) { this.status.textContent = this.strings.empty; return; }
          this.cart = cart;
          this.status.textContent = '';
          this.renderCart();
          this.submitButton.disabled = false;
        } catch {
          if (sequence === this.sequence) this.status.textContent = this.strings.error;
        } finally { clearTimeout(timeout); }
      }

      money(cents) {
        return new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.cart.currency }).format(cents / 100);
      }

      renderCart() {
        const list = this.querySelector('[data-cart-help-items]');
        list.replaceChildren();
        this.cart.items.forEach(item => {
          const row = document.createElement('li');
          row.textContent = `${item.quantity} × ${item.title} — ${this.money(item.final_line_price)}`;
          list.append(row);
        });
        this.querySelector('[data-cart-help-summary]').textContent = this.strings.summary.replace('[count]', this.cart.item_count).replace('[total]', this.money(this.cart.total_price));
        const simple = this.cart.items.every(item => !item.selling_plan_allocation && !Object.keys(item.properties || {}).length && Number.isSafeInteger(item.variant_id) && Number.isSafeInteger(item.quantity) && item.quantity > 0);
        this.link = '';
        if (simple) {
          const quantities = new Map();
          this.cart.items.forEach(item => quantities.set(item.variant_id, (quantities.get(item.variant_id) || 0) + item.quantity));
          const path = Array.from(quantities, ([id, quantity]) => `${id}:${quantity}`).join(',');
          const url = new URL(`${this.dataset.cartUrl}/${path}`, location.origin);
          url.searchParams.set('storefront', 'true');
          if (url.href.length <= 1800) this.link = url.href;
        }
        this.querySelector('[data-cart-help-link]').value = this.link;
        this.querySelector('[data-cart-help-link-wrap]').hidden = !this.link;
        this.querySelector('[data-cart-help-link-unavailable]').hidden = Boolean(this.link);
        this.querySelector('[data-cart-help-cart]').hidden = false;
        this.querySelector('[data-cart-help-body]').value = this.buildBody();
      }

      buildBody() {
        const lines = [this.strings[this.mode], '', ...this.cart.items.flatMap(item => {
          const properties = Object.entries(item.properties || {}).filter(([key, value]) => !key.startsWith('_') && value != null && value !== '').map(([key, value]) => `  ${key}: ${value}`);
          return [`${item.quantity} × ${item.title}`, `SKU: ${item.sku || '—'} | ID: ${item.variant_id}`, this.money(item.final_line_price), new URL(item.url, location.origin).href, ...properties];
        }), '', this.strings.summary.replace('[count]', this.cart.item_count).replace('[total]', this.money(this.cart.total_price)), this.strings.price_note];
        if (this.cart.note) lines.push('', this.cart.note);
        lines.push('', this.link || this.strings.link_unavailable);
        return lines.join('\n');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
